import { configureStore } from "@reduxjs/toolkit";
import rightReducers from "./reducers.js";
export const store = configureStore({
  reducer: {
    rights: rightReducers,
  },
});
